import { useChat } from "./ChatContext";

// Statü senkronu, chat ile aynı socket bağlantısını kullanır (ayrı bağlantı auth'tan geçmiyor).
// Bu hook, ChatContext'in subscribeStatus/emitStatusUpdate fonksiyonlarını dışarı verir.
export function useStatusSocket() {
  const chat = useChat();
  return {
    subscribeStatus: chat?.subscribeStatus ?? (() => () => {}),
    emitStatusUpdate: chat?.emitStatusUpdate ?? (() => {}),
  };
}

// App.js ile uyumluluk için passthrough provider (gerçek bağlantı ChatProvider'da).
export function StatusSocketProvider({ children }) {
  return children;
}
